//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignStartPage",
  props: {
    flow: {
      type: String,
      required: true
    },
    steps: {
      type: Array,
      required: true
    },
    clientApplicationRequests: {
      type: Object,
      required: true
    }
  }
});